import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handleClick(e) {
    const anchor = e.currentTarget.querySelector("a");
    if (anchor) {
      window.location.href = anchor.href;
    }
  }
}
